import normalMode from "../../normalMode";
import UserInfoSettingPrefab from "./UserInfoSettingPrefab";
import O1HD from "../../../../engines/gameEngine";
import UserAccountPrefab from "./UserAccountPrefab";
import NormalGameManager from "../../manager/NormalGameManager";
import { WeChatEvent } from "../../manager/WeChatConst";
import { getOneHeadUrlById, UserHeadConfig } from "../../config/UserHeadConfig";
import AnimValueProgress from "../../../../engines/components/animation/AnimValueProgress";
import CsvDataManage from "../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../define/CsvFileKind";
import { MessageEventKind } from "../../../define/MessageEventKind";
import LevelInfoNode from "../../../gameCommon/basic/LevelInfoNode";
import { GeneralKind } from "../../../define/GeneralKind";
import ShakeNode from "../../../../engines/components/animation/ShakeNode";
import JellyTween from "../../../../engines/components/tweens/JellyTween";
import { PLATFORM_CODE } from "../../../../engines/services/ossService";
import utilsView from "../../../../engines/libs/utilsView";
import { FileKind } from "../../../define/FileKind";
import { UIKind } from "../../../define/UIKind";
import utilsModel from "../../../../engines/libs/utilsModel";
import ShakeTween2 from "../../../../engines/components/tweens/ShakeTween2";

const {ccclass, property} = cc._decorator;
/**
 * 用户节点
 */
@ccclass
export default class UserNode extends cc.Component {

	@property({ type: cc.Sprite, displayName:'' })
	sprOfficialBg: cc.Sprite = null;

    @property({type:cc.Prefab,displayName:"用户设置预制体"})
    userSettingPrefab : cc.Prefab = null;
    @property({type:cc.Prefab,displayName:"用户账本预制体"})
    userAccountPrefab : cc.Prefab = null;
    @property(normalMode)
    normalMode : normalMode = null;
    @property({type:cc.Node})
    redPointNode : cc.Node = null;

    @property({type:cc.Node,displayName:"头像节点"})
    headNode:cc.Node = null;

    @property(cc.Label)
    labelOfficial: cc.Label = null;

    @property(cc.Node)
    levelInfoNode: cc.Node = null;

    @property(cc.Node)
    nodeExam: cc.Node = null;

    private labelLevelName: cc.Label = null;
    private sprLevelBg: cc.Sprite = null;

    
    @property({type:cc.Node,displayName:"等级节点"})
    private levelNode: cc.Node = null;

    private csvInfos = null;

    private levelInfoScript: LevelInfoNode = null;


    onLoad () {}

    start () {
        this.labelLevelName = this.levelNode.getChildByName("labelLevelName").getComponent(cc.Label);
        this.sprLevelBg = this.levelNode.getChildByName("sprLevelBg").getComponent(cc.Sprite);
        this.levelInfoScript = cc.find('LevelInfoNode', this.levelInfoNode).getComponent(LevelInfoNode);
        this.csvInfos = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.LEVEL);
        O1HD.on(WeChatEvent.USERUPDATEHEAD,this.updateHead,this);
        O1HD.on(MessageEventKind.EventName.UPDATE_EXP, this.refreshExp, this);
        O1HD.on(MessageEventKind.EventName.UPDATE_LEVEL, this.refreshLevel, this);
        this.updateHead();
        this.refreshLevel();
        this.refreshExp(true);
    }

    /**
     * 打开用户头像
     */
    onBtnHeadSetting(){
        if (!this.normalMode) {
            return;
        }
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let userSettingNode = cc.instantiate( this.userSettingPrefab );
        userSettingNode.getComponent(UserInfoSettingPrefab).bindData( this.normalMode );
        this.normalMode.node.addChild( userSettingNode );
    }

    /**
     * 打开账单
     */
    onBtnBill(){
        if (!this.normalMode) {
            return;
        }
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let userAccountPrefab = cc.instantiate( this.userAccountPrefab );
        O1HD.Canvas().addChild( userAccountPrefab );
        userAccountPrefab.getComponent( UserAccountPrefab ).bindData( this.normalMode );
    }


    update(dt: number): void {
        if ( NormalGameManager._instance.getGameData().userAccountInfoNewMsg &&
            NormalGameManager._instance.getGameData().userAccountInfoNewMsg > 0 ){
                if (this.redPointNode && !this.redPointNode.active) {
                    this.redPointNode.active = true;
                    let shake = this.redPointNode.parent.getComponent(ShakeTween2);
                    shake.play();
                    // cc.Tween.stopAllByTarget(this.redPointNode.parent);
                    // cc.tween(this.redPointNode.parent)
                    //     .to(0.5, {scale: 1.1})
                    //     .to(0.5, {scale: 0.9})
                    //     // .to(0.5, {scale: 1.1}, {easing: 'circIn'})
                    //     // .to(0.5, {scale: 0.9}, {easing: 'circOut'})
                    //     .union()
                    //     .repeatForever()
                    //     .start();
                }
        }else{
            if (this.redPointNode && this.redPointNode.active) {
                let shake = this.redPointNode.parent.getComponent(ShakeTween2);
                shake.stop();
                // cc.Tween.stopAllByTarget(this.redPointNode.parent);
                this.redPointNode.active = false;
            }
        }
    }

    refreshLevel() {
        let title = this.csvInfos.title;
        let gameData = NormalGameManager._instance.getGameData();
        let officialLv = gameData.m_officialLv;
        let info = this.csvInfos[officialLv];
        if (!info) {
            console.error(`等级表格数据有误`);
            return;
        }

        this.labelOfficial.string = info[title.official_name];
        this.setLevelName(info[title.level_name]);

        let icon = info[title.icon];
        O1HD.getManagers().gameMgr.getCurrMode().bundle.load(
            `res/user/levelIcon/level_bg_${icon}`
            , cc.SpriteFrame
            , ( error , assets : cc.SpriteFrame )=>
            {
                if ( error ) {
                    console.log("图片加载失败");
                    return
                }
                this.sprLevelBg.spriteFrame = assets;
            }
        );
        
        this.labelLevelName.node.color = officialLv == GeneralKind.GeneralValue.MAX_LEVEL
            ? new cc.Color(0xb4,0x5a,0x1d) 
            : new cc.Color(0xff,0xfb,0xef);

        O1HD.getManagers().gameMgr.getCurrMode().bundle.load(
            `res/user/levelIcon/official_bg_${icon}`
            , cc.SpriteFrame
            , ( error , assets : cc.SpriteFrame )=>
            {
                if ( error ) {
                    console.log("图片加载失败");
                    return
                }
                this.sprOfficialBg.spriteFrame = assets;
            }
        );

        this.labelOfficial.node.color = officialLv == GeneralKind.GeneralValue.MAX_LEVEL
            ? new cc.Color(0xff,0xe9,0xab) 
            : new cc.Color(0x00,0x00,0x00);
    }

    setLevelName(name: string) {
        this.labelLevelName.string = name;
    }

    refreshExp(bNoAni: boolean = false) {
        let gameData = NormalGameManager._instance.getGameData();
        let officialLv = gameData.m_officialLv;
        let reputation = gameData.m_reputation;

        let data = CsvDataManage.instance.getExpProgressFromLv(officialLv, reputation);
        if (!data) {
            return;
        }
        // if (data.curExp < 0) {
        //     let curLv = CsvDataManage.instance.getUserUpdateLevel(
        //         reputation
        //         , officialLv
        //     );
        //     if (utilsModel.isValidNumberValue(curLv)) {
        //         officialLv = gameData.m_officialLv = curLv;
        //         NormalGameManager._instance.writeGameData();   
        //         data = CsvDataManage.instance.getExpProgressFromLv(officialLv, reputation);
        //         if (!data) {
        //             return;
        //         }
        //     }
        // }
       

        this.refreshLevel();
        this.levelInfoScript.refreshExp(data.curExp, data.totalExp, data.bMax, !bNoAni);
        // if (data.curExp >= data.totalExp) {
        //     if (!this.nodeExam.active) {
        //         // this.labelOfficial.node.active = false;
        //         this.nodeExam.active = true;
        //         this.sprOfficialBg.getComponent(JellyTween).play();
        //     }
        // } else {
            
        //     if (this.nodeExam.active) {
        //         this.sprOfficialBg.getComponent(JellyTween).stop();
        //         this.nodeExam.active = false;
        //         // this.labelOfficial.node.active = true;
        //     }
        // }
    }

    onClickExam() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();


        let level = NormalGameManager._instance.getGameData().m_officialLv;
        let info = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.LEVEL,level,null);
        if(!info){
            console.log("暂无数据,不能升级");
            return;
        }
        // console.log(info,"info????")
        if(utilsModel.isValidNumberValue(info) && info.eventId != -1){
            // 开启一个升级事件
            NormalGameManager._instance.mGameLayer.openUpGradeEvent(info.eventId);
        }else{
            utilsView.openPopupLayerTwo(
                FileKind.PrefabFilePath.ExamLayer
                , null
                , {}
            );
        }
    }

    onClickAddExpTest() {
        // O1HD.emit("normalMode.guideEnterModule", 'cd');
        if (O1HD.getServices().ossSrv.getPlatform() == PLATFORM_CODE.H5) {
            NormalGameManager._instance.addExp(50);
        }
    }

    updateHead(){
        let headUrl = getOneHeadUrlById(NormalGameManager._instance.getGameData().userCurrHead);
        O1HD.getManagers().gameMgr.getCurrMode().bundle.load(`res/user/head/${headUrl}`,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
            if(err){
                console.log(err);
            }else{
                this.headNode.getComponent(cc.Sprite).spriteFrame = spr;
            }
        });
    }

}
